export default "__VITE_ASSET__CZCTYOjN__"